import { gql } from 'apollo-boost';

export const MANAGED_CONTRACTS = gql`
{
  sptManager {
    myManagedContracts {
      id
      contractId
      contract {
        id
        shortname
        fullname
        startDate
        endDate
      }
      userId
    }
  }
}
`;

export const ACCESS_KEYS = gql`
query($contractId: Int!){
  sptManager {
    accessKeys(contractId: $contractId) {
      id
      key
      selectableCourses
      contract {
        id
        shortname
        fullname
      }
      student {
        id
        first
        last
        uname
        domain
        active
      }
      sptRegistrations {
        id
        courseId
        accessStart
        accessEnd
      }
      courses {
        course {
          id
          name
          acronym
        }
      }
      killAccessDate
    }
  }
}
`;

export const MY_STUDENTS = gql`
query($contractId: Int!, $useCache: Boolean){
  sptManager {
    myStudents(contractId: $contractId, useCache: $useCache) {
      students{
        id
        first
        last
        uname
        domain
        lastLogin
        active
        email
        phone
        sptUser
        iltUser
        moodlePortfolio{
          stringyPortfolio
          certs{
            id
            certId
            name
            description
            descriptionFormat
            duration
            framework
            certifier
            timeCreated
            timeModified
            userModified
  
            radarString
            radar{
                id
                datasets{
                    id
                    label
                    data
                    borderColor
                    backgroundColor
                }
                rows{
                    id
                    chartRowId
                    name
                    sortOrder
                    score{
                        maxMark
                        mark
                    }
                    passing
                }
                reqStatus{
                    id
                    internalId
                    status
                    earned
                    max
                    percentageGrade
                    depth
                    pointsPossible
                    percentageScore
                    competencies{
                        id
                        competencyFrameworkId
                        description
                        descriptionFormat
                        idNumber
                        parentId
                        path
                        ruleConfig
                        ruleOutcome
                        ruleType
                        scaleConfiguration
                        scaleId
                        shortname
                        sortOrder
                        timeCreated
                        timeModified
                        userModified
                        exposed{
                            id
                            value
                            courses{
                                id          
                                moodleId
                                portalId
                                ctxId  
                                competencies
                                
                            }
                            modules{
                                id
                                instance
                                modName
                                module
                                name
                                tags
                                competencies
                            }
                        }
                        practiced{
                            id
                            value
                            courses{
                                id          
                                moodleId
                                portalId
                                ctxId  
                                competencies
                                
                            }
                            modules{
                                id
                                instance
                                modName
                                module
                                name
                                tags
                                competencies
                            }
                        }
                        assessed{
                            id
                            value
                            courses{
                                id          
                                moodleId
                                portalId
                                ctxId  
                                competencies
                                
                            }
                            modules{
                                id
                                instance
                                modName
                                module
                                name
                                tags
                                competencies
                            }
                        }
                    }
                }
            }
            relatedComps
            properties
            reqInfo{
                id
                req
                vals{
                    compList
                    depth
                    pct
                    passing
                    sortOrder
                    radar
                }
                reqRecord{
                    id
                    shortName
                    description
                    descriptionFormat
                    certification
                    type
                    target
                    
                    timeCreated
                    timeModified
                    userModified
                }
                reqStatus{
                    number
                    span
                }
            }
            rec{
                id
                name
                description
                descriptionFormat
                duration
                framework
                certifier
                timeCreated
                timeModified
                userModified
            }
        }
        competencies{
            id
            competencyFrameworkId
            description
            descriptionFormat
            idNumber
            parentId
            path
            ruleConfig
            ruleOutcome
            ruleType
            scaleConfiguration
            scaleId
            shortname
            sortOrder
            timeCreated
            timeModified
            userModified
            exposed{
                id
                value
                courses{
                    id          
                    moodleId
                    portalId
                    ctxId
                    competencies
                    
                }
                modules{
                    id
                    instance
                    modName
                    module
                    name
                    tags
                    competencies
                }
            }
            practiced{
                id
                value
                courses{
                    id          
                    moodleId
                    portalId
                    ctxId     
                    competencies
                    
                }
                modules{
                    id
                    instance
                    modName
                    module
                    name
                    tags
                    competencies
                }
            }
            assessed{
                id
                value
                courses{
                    id          
                    moodleId
                    portalId
                    ctxId  
                    competencies
                    
                }
                modules{
                    id
                    instance
                    modName
                    module
                    name
                    tags
                    competencies
                }
            }
        }
        courses{
            id
            moodleId
            portalId
            portalCourse{
                id
                courseid
                course{
                    id
                    acronym
                    name
                }
                courseNumber
                courseTitle
                startDate
                endDate
                location
                classroom
                primaryInstructor{
                    id
                    uname
                    first
                    last
                }
                secondaryInstructor{
                    id
                    uname
                    first
                    last
                }
                weeks{
                    id
                    week
                    module
                    courseid
                    instructor{
                        id
                        uname
                        first
                        last
                    }
                    backup{
                        id
                        uname
                        first
                        last
                    }
                }
            }
            portalSptCourseId
            portalSptCourse{
                id
                acronym
                name
            }
            portalSptRegistrationId,
            portalSptRegistration{
                id
                courseId
                course{
                    id
                    acronym
                    name
                }
                deployed
                awaitingStart
                availabilityCutoff
                accessStart
                accessEnd
            }
            activities{
                id
                courseId
                categoryId
                itemName
                itemType
                itemModule
                itemInstance
                itemNumber
                itemInfo
                idNumber
                calculation
                gradeType
                gradeMax
                gradeMin
                scaleId
                outcomeId
                gradePass
                multFactor
                plusFactor
                aggregationCoef
                aggregationCoef2
                sortOrder
                display
                decimals
                locked
                lockTime
                needsUpdate
                weightOverride
                timeCreated
                timeModified
                weight
                cmId
                maxMarks
                
                attempt{
                    id
                    lab
                    userId
                    attempt
                    uniqueId
                    layout
                    currentPage
                    preview
                    state
                    timeStart
                    timeFinish
                    timeModified
                    timeModifiedOffline
                    timeCheckState
                    sumGrades
                }

                slots{
                    slot
                    questionId
                    categoryId
                    questionName
                    points{
                        fraction
                        maxMark
                        mark
                    }
                    competencies
                }

                competencies

                finalScore{
                    id
                    itemId
                    userId
                    rawGrade
                    rawGradeMax
                    rawGradeMin
                    rawScaleId
                    userModified
                    finalGrade
                    hidden
                    locked
                    lockTime
                    exported
                    overridden
                    excluded
                    feedback
                    feedbackFormat
                    information
                    informationFormat
                    timeCreated
                    timeModified
                    aggregationStatus
                    aggregationWeight
                }

            }

            regRecordId
            regRecord{
                id
                dbId
                fullName
                acronym
                startDate
                endDate
                location
                classroom
                primary{
                    first
                    last
                    uname
                }
                secondary{
                    first
                    last
                    uname
                }
                selfPaced
            }
            finalScore{
                id
                itemId
                userId
                rawGrade
                rawGradeMax
                rawGradeMin
                rawScaleId
                userModified
                finalGrade
                hidden
                locked
                lockTime
                exported
                overridden
                excluded
                feedback
                feedbackFormat
                information
                informationFormat
                timeCreated
                timeModified
                aggregationStatus
                aggregationWeight
            }
            
            competencies
            category
            courseDesc
            ctxDepth
            ctxId
            ctxInstance
            ctxLevel
            ctxLocked
            ctxPath
            defaultGroupingId
            fullName
            groupMode
            groupModeForce
            idNumber
            shortName
            sortOrder
            startDate
            visible
            courseModules{
                id
                instance
                modName
                module
                name
                tags
                competencies
            }
            
            gradeCategories{
                id
                category{
                    id
                    aggregateOnlyGraded
                    aggregateOutcomes
                    aggregation
                    courseId
                    depth
                    dropLow
                    fullName
                    hidden
                    keepHigh
                    parent
                    path
                    timeCreated
                    timeModified
                }
                finalScore{
                    id
                    itemId
                    userId
                    rawGrade
                    rawGradeMax
                    rawGradeMin
                    rawScaleId
                    userModified
                    finalGrade
                    hidden
                    locked
                    lockTime
                    exported
                    overridden
                    excluded
                    feedback
                    feedbackFormat
                    information
                    informationFormat
                    timeCreated
                    timeModified
                    aggregationStatus
                    aggregationWeight
                }
                
                gradeItem{
                    id
                    aggregateCoef
                    aggregateCoef2
                    calculation
                    categoryId
                    courseId
                    decimals
                    display
                    gradeMax
                    gradeMin
                    gradePass
                    gradeType
                    hidden
                    idNumber
                    itemInfo
                    itemInstance
                    itemModule
                    itemName
                    itemNumber
                    itemType
                    locked
                    lockTime
                    multFactor
                    needsUpdate
                    outcomeId
                    plusFactor
                    scaleId
                    sortOrder
                    timeCreated
                    timeModified
                    weight
                    weightOverride
                }
            }
            industryCerts
            progress
            workroles
        }
        workroles{
            id
            name
            shortCode
            description
            timeCreated
            timeModified
            userModified
            competencies
            specArea{
                id
                categoryId
                name
                shortCode
                description
                timeCreated
                timeModified
                userModified
            }
            category{
                id
                name
                shortCode
                description
                timeCreated
                timeModified
                userModified
            }
            certifications{
                id
                certId
                name
                description
                descriptionFormat
                duration
                framework
                certifier
                timeCreated
                timeModified
                userModified
  
                radarString
                radar{
                    id
                    datasets{
                        id
                        label
                        data
                        borderColor
                        backgroundColor
                    }
                    rows{
                        id
                        chartRowId
                        name
                        sortOrder
                        score{
                            maxMark
                            mark
                        }
                        passing
                    }
                    reqStatus{
                        id
                        internalId
                        status
                        earned
                        max
                        percentageGrade
                        depth
                        pointsPossible
                        percentageScore
                        competencies{
                            id
                            competencyFrameworkId
                            description
                            descriptionFormat
                            idNumber
                            parentId
                            path
                            ruleConfig
                            ruleOutcome
                            ruleType
                            scaleConfiguration
                            scaleId
                            shortname
                            sortOrder
                            timeCreated
                            timeModified
                            userModified
                            exposed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId     
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                practiced{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId   
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                assessed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId     
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                        }
                    }
                }
                relatedComps
                properties
                reqInfo{
                    id
                    req
                    vals{
                        compList
                        depth
                        pct
                        passing
                        sortOrder
                        radar
                    }
                    reqRecord{
                        id
                        shortName
                        description
                        descriptionFormat
                        certification
                        type
                        target
                        
                        timeCreated
                        timeModified
                        userModified
                    }
                    reqStatus{
                        number
                        span
                    }
                }
                rec{
                    id
                    name
                    description
                    descriptionFormat
                    duration
                    framework
                    certifier
                    timeCreated
                    timeModified
                    userModified
                }
            }
  
        }
        }
      }
            iltCombinedPortfolio{
                certs{
                    id
                    certId
                    name
                    description
                    descriptionFormat
                    duration
                    framework
                    certifier
                    timeCreated
                    timeModified
                    userModified

                    radarString
                    radar{
                        id
                        datasets{
                            id
                            label
                            data
                            borderColor
                            backgroundColor
                        }
                        rows{
                            id
                            chartRowId
                            name
                            sortOrder
                            score{
                                maxMark
                                mark
                            }
                            passing
                        }
                        reqStatus{
                            id
                            internalId
                            status
                            earned
                            max
                            percentageGrade
                            depth
                            pointsPossible
                            percentageScore
                            competencies{
                                id
                                competencyFrameworkId
                                description
                                descriptionFormat
                                idNumber
                                parentId
                                path
                                ruleConfig
                                ruleOutcome
                                ruleType
                                scaleConfiguration
                                scaleId
                                shortname
                                sortOrder
                                timeCreated
                                timeModified
                                userModified
                                exposed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                practiced{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                assessed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId    
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                            }
                        }
                    }
                    relatedComps
                    properties
                    reqInfo{
                        id
                        req
                        vals{
                            compList
                            depth
                            pct
                            passing
                            sortOrder
                            radar
                        }
                        reqRecord{
                            id
                            shortName
                            description
                            descriptionFormat
                            certification
                            type
                            target
                            
                            timeCreated
                            timeModified
                            userModified
                        }
                        reqStatus{
                            number
                            span
                        }
                    }
                    rec{
                        id
                        name
                        description
                        descriptionFormat
                        duration
                        framework
                        certifier
                        timeCreated
                        timeModified
                        userModified
                    }
                }
                competencies{
                    id
                    competencyFrameworkId
                    description
                    descriptionFormat
                    idNumber
                    parentId
                    path
                    ruleConfig
                    ruleOutcome
                    ruleType
                    scaleConfiguration
                    scaleId
                    shortname
                    sortOrder
                    timeCreated
                    timeModified
                    userModified
                    exposed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                practiced{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId  
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                assessed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId     
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                }
                courses{
                    id
                    moodleId
                    portalId
                    portalCourse{
                        id
                        courseid
                        course{
                            id
                            acronym
                            name
                        }
                        courseNumber
                        courseTitle
                        startDate
                        endDate
                        location
                        classroom
                        primaryInstructor{
                            id
                            uname
                            first
                            last
                        }
                        secondaryInstructor{
                            id
                            uname
                            first
                            last
                        }
                        weeks{
                            id
                            week
                            module
                            courseid
                            instructor{
                                id
                                uname
                                first
                                last
                            }
                            backup{
                                id
                                uname
                                first
                                last
                            }
                        }
                    }
                    portalSptCourseId
                    portalSptCourse{
                        id
                        acronym
                        name
                    }
                    portalSptRegistrationId,
                    portalSptRegistration{
                        id
                        courseId
                        course{
                            id
                            acronym
                            name
                        }
                        deployed
                        awaitingStart
                        availabilityCutoff
                        accessStart
                        accessEnd
                    }
                    activities{
                        id
                        courseId
                        categoryId
                        itemName
                        itemType
                        itemModule
                        itemInstance
                        itemNumber
                        itemInfo
                        idNumber
                        calculation
                        gradeType
                        gradeMax
                        gradeMin
                        scaleId
                        outcomeId
                        gradePass
                        multFactor
                        plusFactor
                        aggregationCoef
                        aggregationCoef2
                        sortOrder
                        display
                        decimals
                        locked
                        lockTime
                        needsUpdate
                        weightOverride
                        timeCreated
                        timeModified
                        weight
                        cmId
                        maxMarks
                        
                        attempt{
                            id
                            lab
                            userId
                            attempt
                            uniqueId
                            layout
                            currentPage
                            preview
                            state
                            timeStart
                            timeFinish
                            timeModified
                            timeModifiedOffline
                            timeCheckState
                            sumGrades
                        }

                        slots{
                            slot
                            questionId
                            categoryId
                            questionName
                            points{
                                fraction
                                maxMark
                                mark
                            }
                            competencies
                        }

                        competencies

                        finalScore{
                            id
                            itemId
                            userId
                            rawGrade
                            rawGradeMax
                            rawGradeMin
                            rawScaleId
                            userModified
                            finalGrade
                            hidden
                            locked
                            lockTime
                            exported
                            overridden
                            excluded
                            feedback
                            feedbackFormat
                            information
                            informationFormat
                            timeCreated
                            timeModified
                            aggregationStatus
                            aggregationWeight
                        }

                    }

                    regRecordId
                    regRecord{
                        id
                        dbId
                        fullName
                        acronym
                        startDate
                        endDate
                        location
                        classroom
                        primary{
                            first
                            last
                            uname
                        }
                        secondary{
                            first
                            last
                            uname
                        }
                        selfPaced
                    }
                    finalScore{
                        id
                        itemId
                        userId
                        rawGrade
                        rawGradeMax
                        rawGradeMin
                        rawScaleId
                        userModified
                        finalGrade
                        hidden
                        locked
                        lockTime
                        exported
                        overridden
                        excluded
                        feedback
                        feedbackFormat
                        information
                        informationFormat
                        timeCreated
                        timeModified
                        aggregationStatus
                        aggregationWeight
                    }
                    
                    competencies
                    category
                    courseDesc
                    ctxDepth
                    ctxId
                    ctxInstance
                    ctxLevel
                    ctxLocked
                    ctxPath
                    defaultGroupingId
                    fullName
                    groupMode
                    groupModeForce
                    idNumber
                    shortName
                    sortOrder
                    startDate
                    visible
                    courseModules{
                        id
                        instance
                        modName
                        module
                        name
                        tags
                        competencies
                    }
                    
                    gradeCategories{
                        id
                        category{
                            id
                            aggregateOnlyGraded
                            aggregateOutcomes
                            aggregation
                            courseId
                            depth
                            dropLow
                            fullName
                            hidden
                            keepHigh
                            parent
                            path
                            timeCreated
                            timeModified
                        }
                        finalScore{
                            id
                            itemId
                            userId
                            rawGrade
                            rawGradeMax
                            rawGradeMin
                            rawScaleId
                            userModified
                            finalGrade
                            hidden
                            locked
                            lockTime
                            exported
                            overridden
                            excluded
                            feedback
                            feedbackFormat
                            information
                            informationFormat
                            timeCreated
                            timeModified
                            aggregationStatus
                            aggregationWeight
                        }
                        
                        gradeItem{
                            id
                            aggregateCoef
                            aggregateCoef2
                            calculation
                            categoryId
                            courseId
                            decimals
                            display
                            gradeMax
                            gradeMin
                            gradePass
                            gradeType
                            hidden
                            idNumber
                            itemInfo
                            itemInstance
                            itemModule
                            itemName
                            itemNumber
                            itemType
                            locked
                            lockTime
                            multFactor
                            needsUpdate
                            outcomeId
                            plusFactor
                            scaleId
                            sortOrder
                            timeCreated
                            timeModified
                            weight
                            weightOverride
                        }
                    }
                    industryCerts
                    progress
                    workroles
                }
                workroles{
                    id
                    name
                    shortCode
                    description
                    timeCreated
                    timeModified
                    userModified
                    competencies
                    specArea{
                        id
                        categoryId
                        name
                        shortCode
                        description
                        timeCreated
                        timeModified
                        userModified
                    }
                    category{
                        id
                        name
                        shortCode
                        description
                        timeCreated
                        timeModified
                        userModified
                    }
                    certifications{
                        id
                        certId
                        name
                        description
                        descriptionFormat
                        duration
                        framework
                        certifier
                        timeCreated
                        timeModified
                        userModified

                        radarString
                        radar{
                            id
                            datasets{
                                id
                                label
                                data
                                borderColor
                                backgroundColor
                            }
                            rows{
                                id
                                chartRowId
                                name
                                sortOrder
                                score{
                                    maxMark
                                    mark
                                }
                                passing
                            }
                            reqStatus{
                                id
                                internalId
                                status
                                earned
                                max
                                percentageGrade
                                depth
                                pointsPossible
                                percentageScore
                                competencies{
                                    id
                                    competencyFrameworkId
                                    description
                                    descriptionFormat
                                    idNumber
                                    parentId
                                    path
                                    ruleConfig
                                    ruleOutcome
                                    ruleType
                                    scaleConfiguration
                                    scaleId
                                    shortname
                                    sortOrder
                                    timeCreated
                                    timeModified
                                    userModified
                                    exposed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId       
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                practiced{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId    
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                assessed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId   
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                }
                            }
                        }
                        relatedComps
                        properties
                        reqInfo{
                            id
                            req
                            vals{
                                compList
                                depth
                                pct
                                passing
                                sortOrder
                                radar
                            }
                            reqRecord{
                                id
                                shortName
                                description
                                descriptionFormat
                                certification
                                type
                                target
                                
                                timeCreated
                                timeModified
                                userModified
                            }
                            reqStatus{
                                number
                                span
                            }
                        }
                        rec{
                            id
                            name
                            description
                            descriptionFormat
                            duration
                            framework
                            certifier
                            timeCreated
                            timeModified
                            userModified
                        }
                    }

                }
            }
            sptCombinedPortfolio{
                certs{
                    id
                    certId
                    name
                    description
                    descriptionFormat
                    duration
                    framework
                    certifier
                    timeCreated
                    timeModified
                    userModified

                    radarString
                    radar{
                        id
                        datasets{
                            id
                            label
                            data
                            borderColor
                            backgroundColor
                        }
                        rows{
                            id
                            chartRowId
                            name
                            sortOrder
                            score{
                                maxMark
                                mark
                            }
                            passing
                        }
                        reqStatus{
                            id
                            internalId
                            status
                            earned
                            max
                            percentageGrade
                            depth
                            pointsPossible
                            percentageScore
                            competencies{
                                id
                                competencyFrameworkId
                                description
                                descriptionFormat
                                idNumber
                                parentId
                                path
                                ruleConfig
                                ruleOutcome
                                ruleType
                                scaleConfiguration
                                scaleId
                                shortname
                                sortOrder
                                timeCreated
                                timeModified
                                userModified
                                exposed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId       
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                practiced{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId     
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                assessed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId   
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                            }
                        }
                    }
                    relatedComps
                    properties
                    reqInfo{
                        id
                        req
                        vals{
                            compList
                            depth
                            pct
                            passing
                            sortOrder
                            radar
                        }
                        reqRecord{
                            id
                            shortName
                            description
                            descriptionFormat
                            certification
                            type
                            target
                            
                            timeCreated
                            timeModified
                            userModified
                        }
                        reqStatus{
                            number
                            span
                        }
                    }
                    rec{
                        id
                        name
                        description
                        descriptionFormat
                        duration
                        framework
                        certifier
                        timeCreated
                        timeModified
                        userModified
                    }
                }
                competencies{
                    id
                    competencyFrameworkId
                    description
                    descriptionFormat
                    idNumber
                    parentId
                    path
                    ruleConfig
                    ruleOutcome
                    ruleType
                    scaleConfiguration
                    scaleId
                    shortname
                    sortOrder
                    timeCreated
                    timeModified
                    userModified
                    exposed{
                        id
                        value
                        courses{
                            id          
                            moodleId
                            portalId
                            ctxId  
                            competencies
                            
                        }
                        modules{
                            id
                            instance
                            modName
                            module
                            name
                            tags
                            competencies
                        }
                    }
                    practiced{
                        id
                        value
                        courses{
                            id          
                            moodleId
                            portalId
                            ctxId     
                            competencies
                            
                        }
                        modules{
                            id
                            instance
                            modName
                            module
                            name
                            tags
                            competencies
                        }
                    }
                    assessed{
                        id
                        value
                        courses{
                            id          
                            moodleId
                            portalId
                            ctxId   
                            competencies
                            
                        }
                        modules{
                            id
                            instance
                            modName
                            module
                            name
                            tags
                            competencies
                        }
                    }
                }
                courses{
                    id
                    moodleId
                    portalId
                    portalCourse{
                        id
                        courseid
                        course{
                            id
                            acronym
                            name
                        }
                        courseNumber
                        courseTitle
                        startDate
                        endDate
                        location
                        classroom
                        primaryInstructor{
                            id
                            uname
                            first
                            last
                        }
                        secondaryInstructor{
                            id
                            uname
                            first
                            last
                        }
                        weeks{
                            id
                            week
                            module
                            courseid
                            instructor{
                                id
                                uname
                                first
                                last
                            }
                            backup{
                                id
                                uname
                                first
                                last
                            }
                        }
                    }
                    portalSptCourseId
                    portalSptCourse{
                        id
                        acronym
                        name
                    }
                    portalSptRegistrationId,
                    portalSptRegistration{
                        id
                        courseId
                        course{
                            id
                            acronym
                            name
                        }
                        deployed
                        awaitingStart
                        availabilityCutoff
                        accessStart
                        accessEnd
                    }
                    activities{
                        id
                        courseId
                        categoryId
                        itemName
                        itemType
                        itemModule
                        itemInstance
                        itemNumber
                        itemInfo
                        idNumber
                        calculation
                        gradeType
                        gradeMax
                        gradeMin
                        scaleId
                        outcomeId
                        gradePass
                        multFactor
                        plusFactor
                        aggregationCoef
                        aggregationCoef2
                        sortOrder
                        display
                        decimals
                        locked
                        lockTime
                        needsUpdate
                        weightOverride
                        timeCreated
                        timeModified
                        weight
                        cmId
                        maxMarks
                        
                        attempt{
                            id
                            lab
                            userId
                            attempt
                            uniqueId
                            layout
                            currentPage
                            preview
                            state
                            timeStart
                            timeFinish
                            timeModified
                            timeModifiedOffline
                            timeCheckState
                            sumGrades
                        }

                        slots{
                            slot
                            questionId
                            categoryId
                            questionName
                            points{
                                fraction
                                maxMark
                                mark
                            }
                            competencies
                        }

                        competencies

                        finalScore{
                            id
                            itemId
                            userId
                            rawGrade
                            rawGradeMax
                            rawGradeMin
                            rawScaleId
                            userModified
                            finalGrade
                            hidden
                            locked
                            lockTime
                            exported
                            overridden
                            excluded
                            feedback
                            feedbackFormat
                            information
                            informationFormat
                            timeCreated
                            timeModified
                            aggregationStatus
                            aggregationWeight
                        }

                    }

                    regRecordId
                    regRecord{
                        id
                        dbId
                        fullName
                        acronym
                        startDate
                        endDate
                        location
                        classroom
                        primary{
                            first
                            last
                            uname
                        }
                        secondary{
                            first
                            last
                            uname
                        }
                        selfPaced
                    }
                    finalScore{
                        id
                        itemId
                        userId
                        rawGrade
                        rawGradeMax
                        rawGradeMin
                        rawScaleId
                        userModified
                        finalGrade
                        hidden
                        locked
                        lockTime
                        exported
                        overridden
                        excluded
                        feedback
                        feedbackFormat
                        information
                        informationFormat
                        timeCreated
                        timeModified
                        aggregationStatus
                        aggregationWeight
                    }
                    
                    competencies
                    category
                    courseDesc
                    ctxDepth
                    ctxId
                    ctxInstance
                    ctxLevel
                    ctxLocked
                    ctxPath
                    defaultGroupingId
                    fullName
                    groupMode
                    groupModeForce
                    idNumber
                    shortName
                    sortOrder
                    startDate
                    visible
                    courseModules{
                        id
                        instance
                        modName
                        module
                        name
                        tags
                        competencies
                    }
                    
                    gradeCategories{
                        id
                        category{
                            id
                            aggregateOnlyGraded
                            aggregateOutcomes
                            aggregation
                            courseId
                            depth
                            dropLow
                            fullName
                            hidden
                            keepHigh
                            parent
                            path
                            timeCreated
                            timeModified
                        }
                        finalScore{
                            id
                            itemId
                            userId
                            rawGrade
                            rawGradeMax
                            rawGradeMin
                            rawScaleId
                            userModified
                            finalGrade
                            hidden
                            locked
                            lockTime
                            exported
                            overridden
                            excluded
                            feedback
                            feedbackFormat
                            information
                            informationFormat
                            timeCreated
                            timeModified
                            aggregationStatus
                            aggregationWeight
                        }
                        
                        gradeItem{
                            id
                            aggregateCoef
                            aggregateCoef2
                            calculation
                            categoryId
                            courseId
                            decimals
                            display
                            gradeMax
                            gradeMin
                            gradePass
                            gradeType
                            hidden
                            idNumber
                            itemInfo
                            itemInstance
                            itemModule
                            itemName
                            itemNumber
                            itemType
                            locked
                            lockTime
                            multFactor
                            needsUpdate
                            outcomeId
                            plusFactor
                            scaleId
                            sortOrder
                            timeCreated
                            timeModified
                            weight
                            weightOverride
                        }
                    }
                    industryCerts
                    progress
                    workroles
                }
                workroles{
                    id
                    name
                    shortCode
                    description
                    timeCreated
                    timeModified
                    userModified
                    competencies
                    specArea{
                        id
                        categoryId
                        name
                        shortCode
                        description
                        timeCreated
                        timeModified
                        userModified
                    }
                    category{
                        id
                        name
                        shortCode
                        description
                        timeCreated
                        timeModified
                        userModified
                    }
                    certifications{
                        id
                        certId
                        name
                        description
                        descriptionFormat
                        duration
                        framework
                        certifier
                        timeCreated
                        timeModified
                        userModified

                        radarString
                        radar{
                            id
                            datasets{
                                id
                                label
                                data
                                borderColor
                                backgroundColor
                            }
                            rows{
                                id
                                chartRowId
                                name
                                sortOrder
                                score{
                                    maxMark
                                    mark
                                }
                                passing
                            }
                            reqStatus{
                                id
                                internalId
                                status
                                earned
                                max
                                percentageGrade
                                depth
                                pointsPossible
                                percentageScore
                                competencies{
                                    id
                                    competencyFrameworkId
                                    description
                                    descriptionFormat
                                    idNumber
                                    parentId
                                    path
                                    ruleConfig
                                    ruleOutcome
                                    ruleType
                                    scaleConfiguration
                                    scaleId
                                    shortname
                                    sortOrder
                                    timeCreated
                                    timeModified
                                    userModified
                                    exposed{
                                        id
                                        value
                                        courses{
                                            id          
                                            moodleId
                                            portalId
                                            ctxId
                                            competencies
                                            
                                        }
                                        modules{
                                            id
                                            instance
                                            modName
                                            module
                                            name
                                            tags
                                            competencies
                                        }
                                    }
                                    practiced{
                                        id
                                        value
                                        courses{
                                            id          
                                            moodleId
                                            portalId
                                            ctxId   
                                            competencies
                                            
                                        }
                                        modules{
                                            id
                                            instance
                                            modName
                                            module
                                            name
                                            tags
                                            competencies
                                        }
                                    }
                                    assessed{
                                        id
                                        value
                                        courses{
                                            id          
                                            moodleId
                                            portalId
                                            ctxId   
                                            competencies
                                            
                                        }
                                        modules{
                                            id
                                            instance
                                            modName
                                            module
                                            name
                                            tags
                                            competencies
                                        }
                                    }
                                }
                            }
                        }
                        relatedComps
                        properties
                        reqInfo{
                            id
                            req
                            vals{
                                compList
                                depth
                                pct
                                passing
                                sortOrder
                                radar
                            }
                            reqRecord{
                                id
                                shortName
                                description
                                descriptionFormat
                                certification
                                type
                                target
                                
                                timeCreated
                                timeModified
                                userModified
                            }
                            reqStatus{
                                number
                                span
                            }
                        }
                        rec{
                            id
                            name
                            description
                            descriptionFormat
                            duration
                            framework
                            certifier
                            timeCreated
                            timeModified
                            userModified
                        }
                    }

                }
            }
            combinedPortfolio{
                certs{
                id
                certId
                name
                description
                descriptionFormat
                duration
                framework
                certifier
                timeCreated
                timeModified
                userModified

                radarString
                radar{
                    id
                    datasets{
                        id
                        label
                        data
                        borderColor
                        backgroundColor
                    }
                    rows{
                        id
                        chartRowId
                        name
                        sortOrder
                        score{
                            maxMark
                            mark
                        }
                        passing
                    }
                    reqStatus{
                        id
                        internalId
                        status
                        earned
                        max
                        percentageGrade
                        depth
                        pointsPossible
                        percentageScore
                        competencies{
                            id
                            competencyFrameworkId
                            description
                            descriptionFormat
                            idNumber
                            parentId
                            path
                            ruleConfig
                            ruleOutcome
                            ruleType
                            scaleConfiguration
                            scaleId
                            shortname
                            sortOrder
                            timeCreated
                            timeModified
                            userModified
                            exposed{
                                id
                                value
                                courses{
                                    id          
                                    moodleId
                                    portalId
                                    ctxId
                                    competencies
                                    
                                }
                                modules{
                                    id
                                    instance
                                    modName
                                    module
                                    name
                                    tags
                                    competencies
                                }
                            }
                            practiced{
                                id
                                value
                                courses{
                                    id          
                                    moodleId
                                    portalId
                                    ctxId
                                    competencies
                                    
                                }
                                modules{
                                    id
                                    instance
                                    modName
                                    module
                                    name
                                    tags
                                    competencies
                                }
                            }
                            assessed{
                                id
                                value
                                courses{
                                    id          
                                    moodleId
                                    portalId
                                    ctxId    
                                    competencies
                                    
                                }
                                modules{
                                    id
                                    instance
                                    modName
                                    module
                                    name
                                    tags
                                    competencies
                                }
                            }
                        }
                    }
                }
                relatedComps
                properties
                reqInfo{
                    id
                    req
                    vals{
                        compList
                        depth
                        pct
                        passing
                        sortOrder
                        radar
                    }
                    reqRecord{
                        id
                        shortName
                        description
                        descriptionFormat
                        certification
                        type
                        target
                        
                        timeCreated
                        timeModified
                        userModified
                    }
                    reqStatus{
                        number
                        span
                    }
                }
                rec{
                    id
                    name
                    description
                    descriptionFormat
                    duration
                    framework
                    certifier
                    timeCreated
                    timeModified
                    userModified
                }
            }
            competencies{
                id
                competencyFrameworkId
                description
                descriptionFormat
                idNumber
                parentId
                path
                ruleConfig
                ruleOutcome
                ruleType
                scaleConfiguration
                scaleId
                shortname
                sortOrder
                timeCreated
                timeModified
                userModified
                exposed{
                    id
                    value
                    courses{
                        id          
                        moodleId
                        portalId
                        ctxId
                        competencies
                        
                    }
                    modules{
                        id
                        instance
                        modName
                        module
                        name
                        tags
                        competencies
                    }
                }
                practiced{
                    id
                    value
                    courses{
                        id          
                        moodleId
                        portalId
                        ctxId    
                        competencies
                        
                    }
                    modules{
                        id
                        instance
                        modName
                        module
                        name
                        tags
                        competencies
                    }
                }
                assessed{
                    id
                    value
                    courses{
                        id          
                        moodleId
                        portalId
                        ctxId    
                        competencies
                        
                    }
                    modules{
                        id
                        instance
                        modName
                        module
                        name
                        tags
                        competencies
                    }
                }
            }
            courses{
                id
                moodleId
                portalId
                portalCourse{
                    id
                    courseid
                    course{
                        id
                        acronym
                        name
                    }
                    courseNumber
                    courseTitle
                    startDate
                    endDate
                    location
                    classroom
                    primaryInstructor{
                        id
                        uname
                        first
                        last
                    }
                    secondaryInstructor{
                        id
                        uname
                        first
                        last
                    }
                    weeks{
                        id
                        week
                        module
                        courseid
                        instructor{
                            id
                            uname
                            first
                            last
                        }
                        backup{
                            id
                            uname
                            first
                            last
                        }
                    }
                }
                portalSptCourseId
                portalSptCourse{
                    id
                    acronym
                    name
                }
                portalSptRegistrationId,
                portalSptRegistration{
                    id
                    courseId
                    course{
                        id
                        acronym
                        name
                    }
                    deployed
                    awaitingStart
                    availabilityCutoff
                    accessStart
                    accessEnd
                }
                activities{
                    id
                    courseId
                    categoryId
                    itemName
                    itemType
                    itemModule
                    itemInstance
                    itemNumber
                    itemInfo
                    idNumber
                    calculation
                    gradeType
                    gradeMax
                    gradeMin
                    scaleId
                    outcomeId
                    gradePass
                    multFactor
                    plusFactor
                    aggregationCoef
                    aggregationCoef2
                    sortOrder
                    display
                    decimals
                    locked
                    lockTime
                    needsUpdate
                    weightOverride
                    timeCreated
                    timeModified
                    weight
                    cmId
                    maxMarks
                    
                    attempt{
                        id
                        lab
                        userId
                        attempt
                        uniqueId
                        layout
                        currentPage
                        preview
                        state
                        timeStart
                        timeFinish
                        timeModified
                        timeModifiedOffline
                        timeCheckState
                        sumGrades
                    }

                    slots{
                        slot
                        questionId
                        categoryId
                        questionName
                        points{
                            fraction
                            maxMark
                            mark
                        }
                        competencies
                    }

                    competencies

                    finalScore{
                        id
                        itemId
                        userId
                        rawGrade
                        rawGradeMax
                        rawGradeMin
                        rawScaleId
                        userModified
                        finalGrade
                        hidden
                        locked
                        lockTime
                        exported
                        overridden
                        excluded
                        feedback
                        feedbackFormat
                        information
                        informationFormat
                        timeCreated
                        timeModified
                        aggregationStatus
                        aggregationWeight
                    }

                }

                regRecordId
                regRecord{
                    id
                    dbId
                    fullName
                    acronym
                    startDate
                    endDate
                    location
                    classroom
                    primary{
                        first
                        last
                        uname
                    }
                    secondary{
                        first
                        last
                        uname
                    }
                    selfPaced
                }
                finalScore{
                    id
                    itemId
                    userId
                    rawGrade
                    rawGradeMax
                    rawGradeMin
                    rawScaleId
                    userModified
                    finalGrade
                    hidden
                    locked
                    lockTime
                    exported
                    overridden
                    excluded
                    feedback
                    feedbackFormat
                    information
                    informationFormat
                    timeCreated
                    timeModified
                    aggregationStatus
                    aggregationWeight
                }
                
                competencies
                category
                courseDesc
                ctxDepth
                ctxId
                ctxInstance
                ctxLevel
                ctxLocked
                ctxPath
                defaultGroupingId
                fullName
                groupMode
                groupModeForce
                idNumber
                shortName
                sortOrder
                startDate
                visible
                courseModules{
                    id
                    instance
                    modName
                    module
                    name
                    tags
                    competencies
                }
                
                gradeCategories{
                    id
                    category{
                        id
                        aggregateOnlyGraded
                        aggregateOutcomes
                        aggregation
                        courseId
                        depth
                        dropLow
                        fullName
                        hidden
                        keepHigh
                        parent
                        path
                        timeCreated
                        timeModified
                    }
                    finalScore{
                        id
                        itemId
                        userId
                        rawGrade
                        rawGradeMax
                        rawGradeMin
                        rawScaleId
                        userModified
                        finalGrade
                        hidden
                        locked
                        lockTime
                        exported
                        overridden
                        excluded
                        feedback
                        feedbackFormat
                        information
                        informationFormat
                        timeCreated
                        timeModified
                        aggregationStatus
                        aggregationWeight
                    }
                    
                    gradeItem{
                        id
                        aggregateCoef
                        aggregateCoef2
                        calculation
                        categoryId
                        courseId
                        decimals
                        display
                        gradeMax
                        gradeMin
                        gradePass
                        gradeType
                        hidden
                        idNumber
                        itemInfo
                        itemInstance
                        itemModule
                        itemName
                        itemNumber
                        itemType
                        locked
                        lockTime
                        multFactor
                        needsUpdate
                        outcomeId
                        plusFactor
                        scaleId
                        sortOrder
                        timeCreated
                        timeModified
                        weight
                        weightOverride
                    }
                }
                industryCerts
                progress
                workroles
            }
            workroles{
                id
                name
                shortCode
                description
                timeCreated
                timeModified
                userModified
                competencies
                specArea{
                    id
                    categoryId
                    name
                    shortCode
                    description
                    timeCreated
                    timeModified
                    userModified
                }
                category{
                    id
                    name
                    shortCode
                    description
                    timeCreated
                    timeModified
                    userModified
                }
                certifications{
                    id
                    certId
                    name
                    description
                    descriptionFormat
                    duration
                    framework
                    certifier
                    timeCreated
                    timeModified
                    userModified

                    radarString
                    radar{
                        id
                        datasets{
                            id
                            label
                            data
                            borderColor
                            backgroundColor
                        }
                        rows{
                            id
                            chartRowId
                            name
                            sortOrder
                            score{
                                maxMark
                                mark
                            }
                            passing
                        }
                        reqStatus{
                            id
                            internalId
                            status
                            earned
                            max
                            percentageGrade
                            depth
                            pointsPossible
                            percentageScore
                            competencies{
                                id
                                competencyFrameworkId
                                description
                                descriptionFormat
                                idNumber
                                parentId
                                path
                                ruleConfig
                                ruleOutcome
                                ruleType
                                scaleConfiguration
                                scaleId
                                shortname
                                sortOrder
                                timeCreated
                                timeModified
                                userModified
                                exposed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                practiced{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                                assessed{
                                    id
                                    value
                                    courses{
                                        id          
                                        moodleId
                                        portalId
                                        ctxId 
                                        competencies
                                        
                                    }
                                    modules{
                                        id
                                        instance
                                        modName
                                        module
                                        name
                                        tags
                                        competencies
                                    }
                                }
                            }
                        }
                    }
                    relatedComps
                    properties
                    reqInfo{
                        id
                        req
                        vals{
                            compList
                            depth
                            pct
                            passing
                            sortOrder
                            radar
                        }
                        reqRecord{
                            id
                            shortName
                            description
                            descriptionFormat
                            certification
                            type
                            target
                            
                            timeCreated
                            timeModified
                            userModified
                        }
                        reqStatus{
                            number
                            span
                        }
                    }
                    rec{
                        id
                        name
                        description
                        descriptionFormat
                        duration
                        framework
                        certifier
                        timeCreated
                        timeModified
                        userModified
                    }
                }

            }
        }
      
    }
  }
}
`;